import { useCallback, useState } from 'react'
import classNames from 'classnames'

import { useConstant } from '../../../../hooks'
import { BUTTON_HEIGHT_24, ButtonArrow } from '../../../Button'

import * as styles from './Controls.module.css'

function Controls({ header = 'Controls', value, onChange, ...divProps }) {
  const [expanded, setExpanded] = useState(true)

  const handleHeaderClick = useConstant(() => () => {
    setExpanded(currExpanded => !currExpanded)
  })

  const handleControlChange = useCallback(
    (control, props) => {
      onChange(value.update(control.name, props))
    },
    [onChange, value]
  )

  const mods = { [styles.expanded]: expanded }

  return value ? (
    <div {...divProps} className={classNames(styles.Controls, mods)}>
      <div
        className={classNames(styles.header, mods)}
        onClick={handleHeaderClick}
      >
        <div className={styles.title}>{header}</div>
        <ButtonArrow height={BUTTON_HEIGHT_24} isOpen={expanded} />
      </div>

      <div className={classNames(styles.children, mods)}>
        {Object.keys(value.getControls())
          .sort((name1, name2) => name1.localeCompare(name2))
          .map(name => {
            const { [name]: config } = value.getControls()

            return config ? (
              <config.Control
                key={config.name}
                value={config}
                onChange={handleControlChange}
              />
            ) : null
          })}
      </div>
    </div>
  ) : null
}

export default Controls
